import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';

import Menu from '../Menu';

import { useNavigate } from 'react-router-dom';

import SuccessMessage from '../../components/successMessage';

import FailedMessage from '../../components/FailedMessage';

import Switch from '../../components/Switch';

import useApiUrls from '../../useApiUrls';

import Pagination from "../components/Pagination";



const Audio = () => {

  const [data, setData] = useState([]);

  const [message, setMessage] = useState("");

  const [playingAudioId, setPlayingAudioId] = useState(null);

  const [pageNo, setPageNo] = useState(0);

  const [pageSize, setPageSize] = useState(100);

  const [hasMore, setHasMore] = useState(true);

  const [totalItems, setTotalItems] = useState(0);

  const navigate = useNavigate();

  const { getUrlByOperation } = useApiUrls();



  // Fallback URLs for common operations

  const fallbackUrls = {

    "AudioDelete": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/Delete",

    "AudioActive": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/UpdateStatus/Active",

    "AudioDeactive": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/UpdateStatus/Deactive",

    "AudioSearch": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/Search",

    "AudioInsert": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/Insert",

    "AudioUpdate": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/Update",

    "AudioGet": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/Get/",

    "AudioGetDistinct": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/GetDistinct/",

    "AudioReGenerate/PublishId": "https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/ReGenerate/PublishId",

    "POSOperation/GetDistinct/merchantid": "https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/merchantid",

    "POSOperation/GetDistinct/specificmerchantid": "https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/specificmerchantid/",

    "SubGroupOperation/GroupAndSubGroup": "https://api.dqr-display-tms.eventum.co.in/api/SubGroupOperation/GroupAndSubGroup",

    "SendToDevice/General": "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/General",

    "SendToDevice/SG/GeneralAll": "https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/GeneralAll"

  };



  // Safe wrapper for getUrlByOperation with fallback

  const safeGetUrlByOperation = (operationType) => {

    try {

      const url = getUrlByOperation(operationType);

      if (url) {

        return url;

      }

      console.warn(`API URL not found for ${operationType}, using fallback`);

      return fallbackUrls[operationType];

    } catch (error) {

      console.error(`Error getting URL for ${operationType}:`, error);

      return fallbackUrls[operationType];

    }

  };

  const audioRef = useRef(null);

  const token = getCookie("token");

  const userid = getCookie("userid");

  const [publishInfo, setPublishInfo] = useState({});

  const [publishLoading, setPublishLoading] = useState(false);



  // Send Audio Dialog states

  const [showSendDialog, setShowSendDialog] = useState(false);

  const [sendMode, setSendMode] = useState('single'); // 'single' or 'group'

  const [selectedAudio, setSelectedAudio] = useState(null);

  const [sendLoading, setSendLoading] = useState(false);

  const [merchants, setMerchants] = useState([]);

  const [selectedMerchant, setSelectedMerchant] = useState("");

  const [loadingMerchants, setLoadingMerchants] = useState(false);

  const [storeList, setStoreList] = useState([]);

  const [selectedStore, setSelectedStore] = useState("");

  const [loadingStores, setLoadingStores] = useState(false);

  const [posList, setPosList] = useState([]);

  const [selectedPos, setSelectedPos] = useState("");

  const [loadingPos, setLoadingPos] = useState(false);

  const [selectedSubgroups, setSelectedSubgroups] = useState([]);

  const [groupList, setGroupList] = useState([]);

  const [loadingGroups, setLoadingGroups] = useState(false);



  // Function to fetch audio data

  const fetchCatelogData = async () => {

    const requestBody = {

      filesize: 0,

      id: 0,

      applycreateddate: false,

      fromcreateddate: 0,

      endcreateddate: 0,

      active: "",

      orgfilename: "",

      systemfilename: "",

      downloadpath: "",

      name: "",

      ispageload: false,

      pagesize: pageSize,

      currentpageno: pageNo,

      withoutpagination: false,

      pagedirection: "first",

    };



    try {

      const AudioSearch = 'https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/Search';

      const response = await axios.post(AudioSearch, requestBody, {

        headers: {

          'X-Authorization': token,

          'UserId': userid,

          'Content-Type': 'application/json-patch+json',

        }

      });



      if (response.data && Array.isArray(response.data.data)) {

        const rows = response.data.data;

        setData(rows);

        setHasMore(rows.length === Number(pageSize));

        const approximateTotal = (pageNo * Number(pageSize)) + rows.length + (rows.length === Number(pageSize) ? Number(pageSize) : 0);

        setTotalItems(approximateTotal);

      } else {

        setData([]);

        setHasMore(false);

        setTotalItems(0);

      }

    } catch (error) {

      console.error("Error fetching Catalogue data:", error);

      setData([]);

      setHasMore(false);

      setTotalItems(0);

    }

  };



  // Fetch data on initial load

  useEffect(() => {

    fetchCatelogData();

  }, [getUrlByOperation, token, userid, pageNo, pageSize]);



  const handlePageChange = (page) => {

    setPageNo(page - 1);

  };



  const handleItemsPerPageChange = (newItemsPerPage) => {

    setPageSize(newItemsPerPage);

    setPageNo(0);

  };



  const totalPages = hasMore ? pageNo + 2 : pageNo + 1;



  const handleAddPop = () => {

    navigate("/addaudio");

  };



  const handleUpdatePop = (id) => {

    navigate(`/updateaudio/${id}`);

  };



  const handleDelete = async (e) => {
    if (window.confirm("Are you sure you want to delete this audio?")) {
      const requestBody = { id: e.target.id };



      try {

        const AudioDelete = safeGetUrlByOperation("AudioDelete");

        await axios.post(AudioDelete, requestBody, {

          headers: {

            'X-Authorization': token,

            'UserId': userid,

            'Content-Type': 'application/json-patch+json',

          }

        });



        setMessage("Data deleted successfully!");

        fetchCatelogData(); // Call search API again to refresh the list



      } catch (error) {

        console.error("Error deleting item:", error);

        setMessage("Failed to delete data");

      }

    }

  };



  const handleToggle = async (e, item) => {

    const apiUrl = item.active ? safeGetUrlByOperation("AudioDeactive") : safeGetUrlByOperation("AudioActive");

    const requestBody = { id: item.id };



    try {

      await axios.post(apiUrl, requestBody, {

        headers: {

          'X-Authorization': token,

          'UserId': userid,

          'Content-Type': 'application/json-patch+json',

        }

      });

      setData(data.map(d => d.id === item.id ? { ...d, active: !item.active } : d));

    } catch (error) {

      console.error("Error updating status:", error);

    }

  };



  useEffect(() => {

    if (message) {

      const timer = setTimeout(() => {

        setMessage("");

      }, 3000);

      return () => clearTimeout(timer);

    }

  }, [message]);



  const playAudio = (src, id) => {

    setPlayingAudioId(id);

    if (audioRef.current) {

      audioRef.current.src = src;

      audioRef.current.play();

    }

  };



  const pauseAudio = () => {

    setPlayingAudioId(null);

    if (audioRef.current) {

      audioRef.current.pause();

    }

  };



  const handleAudioEnded = () => {

    setPlayingAudioId(null);

  };



  const handleCopyClick = async (id, publishId) => {

    const publishUrl = `${window.location.origin}/CS80/Audio/${publishId}`;



    try {

      await copyToClipboard(publishUrl);

      setMessage("URL copied to clipboard!");

    } catch (error) {

      console.error("Failed to copy URL:", error);

      setMessage("Failed to copy URL to clipboard");

    }

  };



  // Updated handlePublish function with fixed clipboard handling

  const handlePublish = async (id) => {

    setPublishLoading(true);

    try {

      // First, call the API to generate the publish ID

      const response = await axios.post(

        'https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/ReGenerate/PublishId',

        { id },

        {

          headers: {

            'accept': 'text/plain',

            'UserId': userid || '1',

            'X-Authorization': token,

            'Content-Type': 'application/json-patch+json'

          }

        }

      );



      // Check if the API response is successful

      if (response.data && response.data.isresponse) {

        // Get the publish ID from the response

        const publishId = response.data.publishid || "";



        // Generate the publishable URL

        const publishUrl = `${window.location.origin}/Audio-publish/${publishId}`;



        // Update state with the publish info

        setPublishInfo({

          id,

          encodedUrl: publishUrl,

          encodedId: publishId

        });



        // Copy URL to clipboard using your fallback function

        try {

          await copyToClipboard(publishUrl);

          setMessage("URL copied to clipboard!");

        } catch (copyError) {

          console.error("Failed to copy URL:", copyError);

          setMessage("Publish successful, but failed to copy URL to clipboard");

        }



        // Refresh the data to get the updated publishid

        fetchCatelogData();

      } else {

        // Handle API error

        throw new Error(response.data?.errormsg || "Failed to generate publish ID");

      }

    } catch (error) {

      console.error("Error generating publish ID:", error);

      setMessage(error.message || "Failed to generate publish URL");

    } finally {

      setPublishLoading(false);

    }

  };



  // Send Audio Dialog functions

  const handleSendAudio = async () => {

    setSendLoading(true);

    try {

      if (sendMode === 'group') {

        // Group Send API call

        const response = await axios.post(

          'https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/SG/GeneralAll',

          {

            subgroupids: selectedSubgroups,

            actionname: "play_again",

            withaction: true,

            msg: JSON.stringify({

              "action": "play_again",

              "file_name": selectedAudio?.systemfilename || ""

            })

          },

          {

            headers: {

              'accept': 'text/plain',

              'UserId': userid || '1',

              'X-Authorization': token,

              'Content-Type': 'application/json-patch+json'

            }

          }

        );



        if (response.data && response.data.isresponse) {

          setMessage("Audio sent to groups successfully!");

          setShowSendDialog(false);

          setSelectedAudio(null);

          setSelectedMerchant("");

          setSelectedPos("");

          setSelectedSubgroups([]);

          setSendMode('single');

        } else {

          throw new Error(response.data?.errormsg || "Failed to send audio to groups");

        }

      } else {

        // Single mode - this should not be called here, but handle it as fallback

        setMessage("Please use Single Audio button for single send");

      }

    } catch (error) {

      console.error("Error sending audio:", error);

      setMessage(error.message || "Failed to send audio");

    } finally {

      setSendLoading(false);

    }

  };



  const handleSingleAudioSend = async () => {

    console.log("handleSingleAudioSend called");



    // Check if merchant and POS are selected

    if (!selectedMerchant || !selectedPos) {

      setMessage("Please select merchant and POS first");

      return;

    }



    if (!selectedAudio?.systemfilename) {

      setMessage("No audio selected");

      return;

    }



    try {

      const selectedPosObj = posList.find(p => String(p.id) === String(selectedPos));
      const posName = selectedPosObj ? (selectedPosObj.value || selectedPosObj.specificmerchantid || "") : "";

      const response = await axios.post(

        'https://api.dqr-display-tms.eventum.co.in/api/SendToDevice/General',

        {

          merchantname: selectedMerchant,

          storeid: selectedStore,

          posname: posName,

          actionname: "play_again",

          id: parseInt(selectedPos) || 0,

          withaction: false,

          msg: JSON.stringify({

            "action": "play_again",

            "file_name": selectedAudio.systemfilename

          })

        },

        {

          headers: {

            'accept': 'text/plain',

            'UserId': userid || '1',

            'X-Authorization': token,

            'Content-Type': 'application/json'

          }

        }

      );



      if (response.data && response.data.isresponse) {

        setMessage("Audio sent successfully!");

        setShowSendDialog(false); // Close dialog after successful send

        // Clear message after delay to ensure it's visible

        setTimeout(() => {

          setMessage("");

        }, 3000);

      } else {

        throw new Error(response.data?.errormsg || "Failed to send audio");

      }

    } catch (error) {

      console.error("Error sending audio:", error);

      setMessage(error.message || "Failed to send audio");

    }

  };



  const handleOpenSendDialog = (item) => {

    setSelectedAudio(item);

    setShowSendDialog(true);

    setSendMode('single');

    setSelectedMerchant("");

    setSelectedPos("");

    setSelectedSubgroups([]);

    setMerchants([]);

    setPosList([]);

    setGroupList([]);

    fetchMerchants();

  };



  const handleCloseSendDialog = () => {

    setShowSendDialog(false);

    setSelectedAudio(null);

    setSendMode('single');

    setSelectedMerchant("");

    setSelectedStore("");

    setSelectedPos("");

    setSelectedSubgroups([]);

    setMerchants([]);

    setStoreList([]);

    setPosList([]);

    setGroupList([]);

    setMessage("");

  };



  const fetchMerchants = async () => {

    const token = getCookie("token");

    const userid = getCookie("userid");



    if (!token || !userid) {

      console.error("Missing token or userId in localStorage");

      return;

    }



    setLoadingMerchants(true);

    try {

      const response = await axios.get(

        "https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/merchantid",

        {

          headers: {

            "X-Authorization": token,

            UserId: userid,

            "accept": "text/plain",

          },

        }

      );



      if (response.data && Array.isArray(response.data.data)) {

        setMerchants(response.data.data);

      } else {

        setMerchants([]);

      }

    } catch (error) {

      console.error("Error fetching merchants:", error);

    } finally {

      setLoadingMerchants(false);

    }

  };



  const fetchStoresByMerchant = async (merchantName) => {

    if (!merchantName) {

      setStoreList([]);

      return;

    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    setLoadingStores(true);
    try {
      const response = await axios.get(
        `https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/specificstoreidbymerchantid_active/${merchantName}`,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "accept": "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setStoreList(response.data.data.map((item) => item.storeid || item.value || item.id));
      } else {
        setStoreList([]);
      }
    } catch (error) {
      console.error("Error fetching Store details:", error);
      setStoreList([]);
    } finally {
      setLoadingStores(false);
    }
  };

  const fetchPosByStore = async (storeId) => {

    if (!storeId) {

      setPosList([]);

      return;

    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    setLoadingPos(true);
    try {
      const response = await axios.get(
        `https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/specificposbystoreid_active/${storeId}`,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "accept": "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setPosList(response.data.data);
      } else {
        setPosList([]);
      }
    } catch (error) {
      console.error("Error fetching POS details:", error);
      setPosList([]);
    } finally {
      setLoadingPos(false);
    }
  };

  const fetchPosByMerchant = async (merchantName) => {

    if (!merchantName) {

      setPosList([]);

      return;

    }



    const token = getCookie("token");

    const userid = getCookie("userid");



    if (!token || !userid) {

      console.error("Missing token or userId in localStorage");

      return;

    }



    setLoadingPos(true);

    try {

      const response = await axios.get(

        `https://api.dqr-display-tms.eventum.co.in/api/POSOperation/GetDistinct/specificmerchantid/${merchantName}`,

        {

          headers: {

            "X-Authorization": token,

            UserId: userid,

            "accept": "text/plain",

          },

        }

      );



      if (response.data && Array.isArray(response.data.data)) {

        setPosList(response.data.data);

      } else {

        setPosList([]);

      }

    } catch (error) {

      console.error("Error fetching POS details:", error);

      setPosList([]);

    } finally {

      setLoadingPos(false);

    }

  };



  const handleMerchantChange = (e) => {

    const merchantName = e.target.value;

    setSelectedMerchant(merchantName);

    setSelectedStore("");

    setSelectedPos(""); // Reset POS selection

    fetchStoresByMerchant(merchantName);

  };

  const handleStoreChange = (e) => {

    const storeId = e.target.value;

    setSelectedStore(storeId);

    setSelectedPos("");

    if (storeId === "All") {
      setPosList([]);
    } else {
      fetchPosByStore(storeId);
    }

  };



  const fetchGroupAndSubGroup = async () => {

    const token = getCookie("token");

    const userid = getCookie("userid");



    if (!token || !userid) {

      console.error("Missing token or userId in localStorage");

      return;

    }



    setLoadingGroups(true);

    try {

      const response = await axios.get(

        "https://api.dqr-display-tms.eventum.co.in/api/SubGroupOperation/GroupAndSubGroup",

        {

          headers: {

            "X-Authorization": token,

            UserId: userid,

            "accept": "text/plain",

          },

        }

      );



      if (response.data && Array.isArray(response.data.data)) {

        setGroupList(response.data.data);

      } else {

        setGroupList([]);

      }

    } catch (error) {

      console.error("Error fetching groups:", error);

      setGroupList([]);

    } finally {

      setLoadingGroups(false);

    }

  };



  const handleSendModeChange = (mode) => {

    setSendMode(mode);

    setSelectedMerchant("");

    setSelectedStore("");

    setSelectedPos("");

    setStoreList([]);

    setPosList([]);

    if (mode === 'single') {

      fetchMerchants();

    } else if (mode === 'group') {

      fetchGroupAndSubGroup();

    }

  };



  // Handle group selection (select all subgroups in a group)

  const handleGroupSelect = (groupId) => {

    const group = groupList.find((g) => g.id === groupId);

    if (!group || !group.subgroupdata) return;



    const subgroupIds = group.subgroupdata.map((sg) => sg.id);

    const allSelected = subgroupIds.every((id) =>

      selectedSubgroups.includes(id)

    );



    if (allSelected) {

      // Deselect all subgroups in this group

      setSelectedSubgroups(prev => prev.filter(id => !subgroupIds.includes(id)));

    } else {

      // Select all subgroups in this group

      setSelectedSubgroups(prev => [...new Set([...prev, ...subgroupIds])]);

    }

  };



  // Check if all subgroups in a group are selected

  const isGroupFullySelected = (groupId) => {

    const group = groupList.find((g) => g.id === groupId);

    if (!group || !group.subgroupdata || group.subgroupdata.length === 0)

      return false;



    const subgroupIds = group.subgroupdata.map((sg) => sg.id);

    return subgroupIds.every((id) => selectedSubgroups.includes(id));

  };



  // Check if some (but not all) subgroups in a group are selected

  const isGroupPartiallySelected = (groupId) => {

    const group = groupList.find((g) => g.id === groupId);

    if (!group || !group.subgroupdata || group.subgroupdata.length === 0)

      return false;



    const subgroupIds = group.subgroupdata.map((sg) => sg.id);

    const selectedCount = subgroupIds.filter((id) =>

      selectedSubgroups.includes(id)

    ).length;

    return selectedCount > 0 && selectedCount < subgroupIds.length;

  };



  // Handle individual subgroup selection

  const handleSubGroupSelect = (subgroupId) => {

    if (selectedSubgroups.includes(subgroupId)) {

      // Remove subgroup from selection

      setSelectedSubgroups(prev => prev.filter(id => id !== subgroupId));

    } else {

      // Add subgroup to selection

      setSelectedSubgroups(prev => [...prev, subgroupId]);

    }

  };



  useEffect(() => {

    fetchMerchants();

  }, []);



  // Ensure your copyToClipboard function is properly defined 

  function copyToClipboard(text) {

    // Try to use the Clipboard API first

    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {

      return navigator.clipboard.writeText(text)

        .then(() => true)

        .catch(err => {

          console.error('Could not copy text using Clipboard API: ', err);

          return fallbackCopyToClipboard(text);

        });

    } else {

      // Fall back to the textarea method

      return Promise.resolve(fallbackCopyToClipboard(text));

    }

  }



  function fallbackCopyToClipboard(text) {

    // Create a temporary textarea element

    const textArea = document.createElement('textarea');

    textArea.value = text;



    // Make the textarea out of viewport

    textArea.style.position = 'fixed';

    textArea.style.left = '-999999px';

    textArea.style.top = '-999999px';

    document.body.appendChild(textArea);



    // Select and copy

    textArea.focus();

    textArea.select();



    let success = false;

    try {

      success = document.execCommand('copy');

    } catch (err) {

      console.error('Failed to copy with fallback method:', err);

    }



    // Remove the textarea from DOM

    document.body.removeChild(textArea);

    return success;

  }



  const handleUnPublish = async (id, publishId) => {

    try {

      const response = await axios.post(

        'https://api.dqr-display-tms.eventum.co.in/api/AudioOperation/UnPublishId',

        { id },

        {

          headers: {

            'accept': 'text/plain',

            'UserId': userid || '1',

            'X-Authorization': token,

            'Content-Type': 'application/json-patch+json'

          }

        }

      );



      if (response.data && response.data.isresponse) {

        setMessage("Campaign unpublished successfully!");

        fetchCatelogData();

      } else {

        throw new Error(response.data?.errormsg || "Failed to unpublish campaign");

      }

    } catch (error) {

      console.error("Error unpublishing campaign:", error);

      setMessage(error.message || "Failed to unpublish campaign");

    }

  };



  const handleCopyHttp = (key) => {

    const urlToCopy = `http://api.dqr-display-tms.eventum.co.in/api/Share/Audio/${key}`;

    copyToClipboard(urlToCopy)

      .then(() => {

        setMessage("URL copied to clipboard!");

      })

      .catch(err => {

        console.error('Failed to copy: ', err);

      });

  };



  const handleCopyHttps = (key) => {

    const urlToCopy = `https://api.dqr-display-tms.eventum.co.in/api/Share/Audio/${key}`;

    copyToClipboard(urlToCopy)

      .then(() => {

        setMessage("URL copied to clipboard!");

      })

      .catch(err => {

        console.error('Failed to copy: ', err);

      });

  };



  // Function to render the publish column

  const renderPublishColumn = (item) => {

    // If the item already has a publishid, show it with a copy button

    if (item.publishid) {

      // Truncate publishid if it's longer than 5 characters

      const displayId = item.publishid.length > 5

        ? `${item.publishid.substring(0, 5)}...`

        : item.publishid;



      return (

        <div className="d-flex flex-column">

          <div className="mb-2">

            <span className="badge badge-info">{displayId}</span>

          </div>

          <div className="btn-group">

            <button

              className="btn btn-sm btn-outline-primary"

              onClick={() => handleCopyClick(item.id, item.publishid)}

              title="Copy URL"

            >

              <i className="fas fa-copy mr-1"></i> URL

            </button>

            <button

              className="btn btn-sm btn-outline-secondary"

              onClick={() => handleCopyHttp(item.publishid)}

              title="Copy HTTP URL"

            >

              HTTP

            </button>

            <button

              className="btn btn-sm btn-outline-secondary"

              onClick={() => handleCopyHttps(item.publishid)}

              title="Copy HTTPS URL"

            >

              HTTPS

            </button>

            <button

              className="btn btn-sm btn-outline-danger"

              onClick={() => handleUnPublish(item.id, item.publishid)}

              title="Unpublish"

            >

              <i className="fas fa-eye-slash"></i>

            </button>

          </div>

        </div>

      );

    }



    // Check if this item is currently being processed

    if (publishInfo.id === item.id) {

      // Truncate encodedId if it's longer than 5 characters

      const displayId = publishInfo.encodedId && publishInfo.encodedId.length > 5

        ? `${publishInfo.encodedId.substring(0, 5)}...`

        : publishInfo.encodedId;



      return (

        <div className="d-flex flex-column">

          <div className="mb-2">

            <span className="badge badge-info">{displayId}</span>

          </div>

          <button

            className="btn btn-sm btn-outline-primary"

            onClick={() => handleCopyClick(item.id, publishInfo.encodedId)}

            title="Copy URL"

          >

            <i className="fas fa-copy mr-1"></i> Copy URL

          </button>

        </div>

      );

    }



    // If no publishid and not currently processing, show the publish button

    return (

      <button

        className="btn btn-sm btn-success"

        onClick={() => handlePublish(item.id)}

        disabled={publishLoading}

      >

        {publishLoading ? (

          <>

            <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>

            Publishing...

          </>

        ) : (

          <>

            <i className="fas fa-globe mr-1"></i> Publish

          </>

        )}

      </button>

    );

  };



  return (

    <>

      <Menu />

      <div>

        <div className="wrapper">

          <div className="content-wrapper">

            <section className="content-header">

              <div className="container-fluid">

                <div className="row mb-2">

                  <div className="d-flex justify-content-between align-items-center w-100">

                    <h1 className="mb-0">Audio</h1>

                    <div className="btn-group">

                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleAddPop}
                      >
                        Add Audio
                      </button>

                    </div>

                  </div>

                </div>

              </div>

            </section>



            <section className="content">

              <div className="container-fluid">

                <hr />

                <div className="row">

                  <div className="col-12">

                    <div className="card">

                      <div className="card-header"></div>

                      <div className="card-body table-responsive p-0">

                        <table className="table table-hover text-nowrap">

                          <thead>

                            <tr>

                              <th>Id</th>

                              <th>Name</th>

                              <th>Orgfilename</th>

                              <th>System file name</th>

                              <th>File size (KB)</th>

                              <th>Play</th>

                              <th>Action</th>

                              <th>Active</th>

                              {/* <th>Publish</th> */}

                            </tr>

                          </thead>

                          <tbody>

                            {data.map((item, index) => (

                              <tr key={index}>

                                <td>{item.id}</td>

                                <td>{item.name}</td>

                                <td>{item.orgfilename}</td>

                                <td>

                                  <span
                                    title={item.systemfilename}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => alert(item.systemfilename)}
                                  >
                                    {item.systemfilename.length > 15 ? (
                                      `${item.systemfilename.substring(0, 15)}...`
                                    ) : (
                                      item.systemfilename
                                    )}
                                  </span>

                                </td>

                                <td>{(item.filesize / 1024).toFixed(2)} KB</td>

                                <td>

                                  {playingAudioId === item.id ? (
                                    <button onClick={pauseAudio}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-pause-fill" viewBox="0 0 16 16">
                                        <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5m5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5" />
                                      </svg>
                                    </button>
                                  ) : (
                                    <button onClick={() => playAudio(item.downloadpath, item.id)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-play-fill" viewBox="0 0 16 16">
                                        <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393" />
                                      </svg>
                                    </button>
                                  )}
                                </td>

                                <td>

                                  <button
                                    type="button"
                                    className="btn btn-success mr-2"
                                    id={item.id}
                                    onClick={() => handleUpdatePop(item.id)}
                                    title="Update"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>

                                  <button
                                    type="button"

                                    className="btn btn-info mr-2"

                                    onClick={() => handleOpenSendDialog(item)}

                                  >

                                    <i className="fas fa-paper-plane"></i>

                                  </button>

                                  <button

                                    type="button"

                                    className="btn btn-danger"

                                    id={item.id}

                                    onClick={handleDelete}

                                  >

                                    <i className="fas fa-trash"></i>

                                  </button>

                                </td>

                                <td>

                                  <Switch

                                    isOn={item.active}

                                    handleToggle={(e) => handleToggle(e, item)}

                                    id={item.id}

                                  />

                                </td>

                                {/* <td className="text-center">

                                  {renderPublishColumn(item)}

                                </td> */}

                              </tr>

                            ))}

                          </tbody>

                        </table>

                      </div>



                      <Pagination

                        currentPage={pageNo + 1}

                        totalPages={totalPages}

                        onPageChange={handlePageChange}

                        itemsPerPage={pageSize}

                        onItemsPerPageChange={handleItemsPerPageChange}

                        totalItems={totalItems}

                        showPageNumbers={false}

                        showItemsPerPageSelector={true}

                      />

                    </div>

                  </div>

                </div>

              </div>

            </section>

          </div>

        </div>

      </div>



      {/* Send Audio Dialog */}

      {showSendDialog && (

        <div

          className="modal d-block"

          tabIndex="-1"

          style={{

            backgroundColor: "rgba(0,0,0,0.5)",

            display: "block"

          }}

        >

          <div className="modal-dialog modal-dialog-centered" role="document" style={{ width: "100%", maxWidth: "500px" }}>

            <div className="modal-content" style={{ borderRadius: "15px", border: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.2)" }}>

              <div className="modal-header" style={{ borderBottom: "1px solid #f0f0f0", padding: "1.5rem" }}>

                <h5 className="modal-title" style={{ fontWeight: "700", color: "#333", fontSize: "1.25rem" }}>

                  <i className="fas fa-paper-plane mr-2 text-primary"></i>

                  Send Audio

                </h5>

                <button type="button" className="close" onClick={handleCloseSendDialog} style={{ outline: "none" }}>

                  <span aria-hidden="true" style={{ fontSize: "1.5rem" }}>&times;</span>

                </button>

              </div>

              <div className="modal-body" style={{ padding: "1.5rem" }}>

                {message && (

                  <div className="alert alert-info" role="alert">

                    {message}

                  </div>

                )}



                {/* Type Selection Tabs */}

                <div style={{

                  display: "flex",

                  borderRadius: "10px",

                  padding: "4px",

                  marginBottom: "1.5rem"

                }}>

                  <button

                    style={{

                      flex: 1,

                      padding: "10px",

                      border: "none",

                      borderRadius: "8px",

                      color: sendMode === "single" ? "#007bff" : "#6c757d",

                      fontWeight: "600",

                      boxShadow: sendMode === "single" ? "0 2px 8px rgba(0,0,0,0.1)" : "none",

                      transition: "all 0.2s ease",

                      cursor: "pointer"

                    }}

                    onClick={handleSingleAudioSend}

                  >

                    <i className="fas fa-user mr-2"></i>Single Audio

                  </button>

                  <button

                    style={{

                      flex: 1,

                      padding: "10px",

                      border: "none",

                      borderRadius: "8px",

                      color: sendMode === "group" ? "#007bff" : "#6c757d",

                      fontWeight: "600",

                      boxShadow: sendMode === "group" ? "0 2px 8px rgba(0,0,0,0.1)" : "none",

                      transition: "all 0.2s ease",

                      cursor: "pointer"

                    }}

                    onClick={() => handleSendModeChange("group")}

                  >

                    <i className="fas fa-users mr-2"></i>Group Send

                  </button>

                </div>



                {sendMode === 'single' && (

                  <div className="animate__animated animate__fadeIn">

                    <div className="form-group mb-0">

                      <label style={{ fontWeight: "600", color: "#495057", marginBottom: "0.5rem", display: "block" }}>

                        <i className="fas fa-store mr-2 text-muted"></i>Select Merchant

                      </label>

                      <select

                        className="form-control custom-select"

                        value={selectedMerchant}

                        onChange={handleMerchantChange}

                        style={{ borderRadius: "8px", padding: "0.6rem 1rem", height: "auto" }}

                        disabled={loadingMerchants}

                      >

                        <option value="">{loadingMerchants ? "Loading merchants..." : "Select merchant..."}</option>

                        {merchants.map((merchant, index) => (

                          <option key={index} value={merchant.merchantid || merchant}>

                            {merchant.merchantid || merchant}

                          </option>

                        ))}

                      </select>

                    </div>



                    <div className="form-group mb-0">

                      <label style={{ fontWeight: "600", color: "#495057", marginBottom: "0.5rem", display: "block" }}>

                        <i className="fas fa-store-alt mr-2 text-muted"></i>Select Store

                      </label>

                      <select

                        className="form-control custom-select"

                        value={selectedStore}

                        onChange={handleStoreChange}

                        style={{ borderRadius: "8px", padding: "0.6rem 1rem", height: "auto" }}

                        disabled={!selectedMerchant || loadingStores}

                      >

                        <option value="">{loadingStores ? "Loading stores..." : "Select store..."}</option>
                        <option value="All">All</option>

                        {storeList.map((store, index) => (

                          <option key={index} value={store.storeid || store}>

                            {store.storeid || store}

                          </option>

                        ))}

                      </select>

                    </div>



                    <div className="form-group mb-0">

                      <label style={{ fontWeight: "600", color: "#495057", marginBottom: "0.5rem", display: "block" }}>

                        <i className="fas fa-desktop mr-2 text-muted"></i>Select POS

                      </label>

                      <select

                        className="form-control custom-select"

                        value={selectedPos}

                        onChange={(e) => setSelectedPos(e.target.value)}

                        style={{ borderRadius: "8px", padding: "0.6rem 1rem", height: "auto" }}

                        disabled={!selectedStore || loadingPos}

                      >

                         <option value="">{loadingPos ? "Loading POS..." : (!selectedMerchant ? "Select merchant first" : "Select POS...")}</option>
                         <option value="0">All</option>

                        {posList.map((pos, index) => (

                          <option key={index} value={pos.id || pos.value || pos.specificmerchantid || pos}>

                            {pos.value || pos.specificmerchantid || pos}

                          </option>

                        ))}

                      </select>

                    </div>

                  </div>

                )}



                {sendMode === 'group' && (

                  <div className="animate__animated animate__fadeIn">

                    <div className="form-group mb-0">

                      <label style={{ fontWeight: "600", color: "#495057", marginBottom: "0.5rem", display: "block" }}>

                        <i className="fas fa-tags mr-2 text-muted"></i>Select Target Groups

                      </label>

                      <div

                        className="border rounded p-3 bg-light"

                        style={{

                          borderRadius: "10px",

                          border: "1px solid #e0e0e0",

                          maxHeight: "280px",

                          overflowY: "auto",

                          zIndex: 1000,

                          boxShadow: "0 10px 25px rgba(0,0,0,0.15)",

                          animation: "fadeInUp 0.2s ease-out"

                        }}

                      >

                        {groupList.length > 0 ? (

                          groupList.map((group) => (

                            <div key={group.id} style={{ borderBottom: "1px solid #f8f9fa" }}>

                              {/* Group Header */}

                              <div

                                onClick={() => handleGroupSelect(group.id)}

                                style={{

                                  padding: "12px 16px",

                                  cursor: "pointer",

                                  fontWeight: "700",

                                  fontSize: "0.85rem",

                                  display: "flex",

                                  alignItems: "center",

                                  color: "#495057",

                                  textTransform: "uppercase",

                                  letterSpacing: "0.5px"

                                }}

                              >

                                <div style={{ position: "relative", marginRight: "12px" }}>

                                  <input

                                    type="checkbox"

                                    checked={isGroupFullySelected(group.id)}

                                    onClick={(e) => e.stopPropagation()}

                                    onChange={() => handleGroupSelect(group.id)}

                                    ref={(input) => {

                                      if (input) {

                                        input.indeterminate = isGroupPartiallySelected(group.id);

                                      }

                                    }}

                                    style={{

                                      width: "18px",

                                      height: "18px",

                                      cursor: "pointer",

                                      accentColor: "#007bff"

                                    }}

                                  />

                                </div>

                                <i className="fas fa-folder mr-2" style={{ color: "#ffc107" }}></i>

                                {group.name}

                                <span style={{

                                  marginLeft: "auto",

                                  fontSize: "0.75rem",

                                  padding: "2px 8px",

                                  borderRadius: "10px",

                                  color: "#6c757d"

                                }}>

                                  {group.subgroupdata ? group.subgroupdata.length : 0}

                                </span>

                              </div>



                              {/* Subgroups */}

                              {group.subgroupdata && group.subgroupdata.length > 0 && (

                                group.subgroupdata.map((subgroup) => (

                                  <div

                                    key={subgroup.id}

                                    onClick={() => handleSubGroupSelect(subgroup.id)}

                                    style={{

                                      padding: "10px 16px 10px 48px",

                                      cursor: "pointer",

                                      display: "flex",

                                      alignItems: "center",

                                      transition: "background-color 0.2s"

                                    }}

                                  >

                                    <input

                                      type="checkbox"

                                      checked={selectedSubgroups.includes(subgroup.id)}

                                      onClick={(e) => e.stopPropagation()}

                                      onChange={() => handleSubGroupSelect(subgroup.id)}

                                      style={{

                                        width: "16px",

                                        height: "16px",

                                        marginRight: "12px",

                                        cursor: "pointer",

                                        accentColor: "#007bff"

                                      }}

                                    />

                                    <i className="fas fa-layer-group mr-2" style={{ color: "#adb5bd", fontSize: "12px" }}></i>

                                    <span style={{

                                      fontSize: "0.9rem",

                                      color: selectedSubgroups.includes(subgroup.id) ? "#007bff" : "#495057",

                                      fontWeight: selectedSubgroups.includes(subgroup.id) ? "600" : "400"

                                    }}>

                                      {subgroup.name}

                                    </span>

                                  </div>

                                ))

                              )}

                            </div>

                          ))

                        ) : (

                          <div className="text-center text-muted p-3">

                            <i className="fas fa-info-circle mr-2"></i>

                            No groups available

                          </div>

                        )}

                      </div>

                    </div>

                  </div>

                )}

              </div>

              <div className="modal-footer" style={{ borderTop: "1px solid #f0f0f0", padding: "1.25rem 1.5rem", justifyContent: "space-between" }}>

                <button

                  type="button"

                  className="btn"

                  onClick={handleCloseSendDialog}

                  style={{ fontWeight: "600", color: "#6c757d", padding: "0.6rem 1.5rem" }}

                  disabled={sendLoading}

                >

                  Cancel

                </button>

                <button

                  type="button"

                  className="btn btn-primary"

                  onClick={sendMode === 'single' ? handleSingleAudioSend : handleSendAudio}

                  disabled={sendLoading || (sendMode === 'single' && !selectedAudio)}

                  style={{

                    fontWeight: "700",

                    padding: "0.6rem 2rem",

                    borderRadius: "10px",

                    boxShadow: "0 4px 12px rgba(0,123,255,0.3)",

                    transition: "transform 0.2s"

                  }}

                >

                  {sendLoading ? (

                    <>

                      <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>

                      Sending...

                    </>

                  ) : (

                    <>

                      <i className="fas fa-paper-plane mr-2"></i>

                      {sendMode === 'single' ? 'Send Single' : 'Send Group'}

                    </>

                  )}

                </button>

              </div>

            </div>

          </div>

        </div>

      )}



      <audio

        ref={audioRef}

        controls

        style={{ display: 'none' }}

        onEnded={handleAudioEnded}

      >

        <source src="" type="audio/mpeg" />

        Your browser does not support the audio element.

      </audio>



      {message === "Data deleted successfully!" && (

        <SuccessMessage message={message} />

      )}



      {message === "Failed to delete data" && (

        <FailedMessage message={message} />

      )}

    </>

  );

};



export default Audio;



function getCookie(name) {

  const value = `; ${document.cookie}`;

  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) return parts.pop().split(";").shift();

}